import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Fetch, baseUrl } from '../../shared/Fetch';
import { JVInput } from '../../shared/JVInput';

interface IProps {
  singleData: any;
  open: boolean;
  hideDialog: () => void;
  toast: any;
}

interface IMail {
  emailTo: string;
  emailCC: string;
  subject: string;
  emailBody: string;
}

const schema = yup.object({
    emailTo: yup.string().email('Invalid Email')
        .nullable(),
    emailCC:yup.string().email('Invalid Email')
        .nullable(),
    subject: yup.string().required('Email Subject is required')
});


export const CompanyDocumentUpload = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [selectedDocuments, setSelectedDocuments] = useState<any[]>([]);
  const [body, setBody] = useState('');

  const { control, handleSubmit, formState: { errors }, reset } = useForm<IMail>({
    resolver: yupResolver(schema),
    defaultValues: {
        emailTo: '',  // Array of strings
        emailCC: '',  // Array of strings
        subject: '',
        emailBody: ''
    },
    shouldFocusError: false,
});

  const loadTableData = async () => {
    setLoading(true);
    const response = await Fetch('vwPODetails/getCompanyDocument', 'GET', null, `company_ID=${props.singleData.company_ID_Sales}`, props.toast);
    if (response) {
      const data = await response.json();
      setTableData(data);
    } else {
      props.toast.current.show({ severity: 'error', detail: 'Failed To Load Documents', life: 3000 });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (props.open) {
      loadTableData();
    }
  }, [props.open]);

  const onHide = () => {
    props.hideDialog();
    reset();
    setSelectedDocuments([]);
  };

  const sendMail = async (fbody: IMail | any) => {
    if (selectedDocuments.length === 0) {
        props.toast.current.show({ severity: 'error', detail: 'Please select at least one document.', life: 3000 });
        return;
    }

    setLoading(true);

    const attachments = selectedDocuments.map(doc => doc.document_Path);
    console.log("Attachments:", attachments); 
    console.log("Email Body:", body); 

    const payload = {
        ...fbody,
        attachments: attachments,
        emailBody: body
    };

    console.log("Payload:", payload); 

    const response = await Fetch('vwPODetails/mail', 'POST', payload, null, props.toast);
    if (response) {
        onHide();
        props.toast.current.show({ severity: 'success', detail: 'Mail sent successfully.', life: 3000 });
    }
    setLoading(false);
};



  const onSubmit = (data: IMail) => {
    if (body.trim().length === 0) {
      props.toast.current.show({ severity: 'error', detail: 'Mail Body is required.', life: 3000 });
      return;
    }
    sendMail(data);
  };

  const onDocumentSelect = (rowData: any) => {
    const selected = [...selectedDocuments];
    const index = selected.findIndex(doc => doc.document_ID === rowData.document_ID);

    if (index === -1) {
      selected.push(rowData);
    } else {
      selected.splice(index, 1);
    }

    setSelectedDocuments(selected);
  };

  const documentCheckboxTemplate = (rowData: any) => (
    <Checkbox
      checked={selectedDocuments.some(doc => doc.document_ID === rowData.document_ID)}
      onChange={() => onDocumentSelect(rowData)}
    />
  );

  return (
    <Dialog
      visible={props.open}
      style={{ width: '50vw' }}
      header="Add/Edit Company Document"
      modal
      className="p-fluid"
      onHide={onHide}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <JVInput column={2} label="To" control={control} name="emailTo" error={errors.emailTo?.message } />
        <JVInput column={2} label="CC" control={control} name="emailCC" error={ errors.emailCC?.message} />
        <JVInput column={1} required label="Subject" control={control} name="subject" error={errors.subject?.message} />
        <div className="col-12 mb-3">
          <label>Body <span style={{ color: 'red' }}>*</span></label>
          <CKEditor editor={ClassicEditor} data={body} onChange={(event, editor) => setBody(editor.getData())} />
        </div>
        <div className="col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
          <Button label="SEND" type="submit" loading={loading} />
          <Button label="CLOSE" className="p-button-outlined" onClick={onHide} type="button" />
        </div>
      </form>
      <DataTable
        value={tableData}
        size="small"
        tableStyle={{ minWidth: '50rem' }}
        style={{ fontSize: '15px', marginBottom: '10px' }}
        showGridlines
      >
        <Column header="Select" body={documentCheckboxTemplate} />
        <Column header="SN." body={(data, options) => options.rowIndex + 1} />
        <Column field="document_Name" header="Document Name" />
      </DataTable>
    </Dialog>
  );
};
